import { cn } from '@/lib/utils'

interface ISuperPromptsIconProps {
  className?: string
}

export const SuperPromptsIcon = ({ className }: ISuperPromptsIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="superPromptsIconTitle"
      role="img"
      className={cn('w-4 h-4', className)}
    >
      <title id="superPromptsIconTitle">Super Prompts Icon</title>
      <g clipPath="url(#clip0_19521_16900)">
        <path
          d="M7.76399 2.93502C7.82443 2.69236 8.16932 2.69236 8.22976 2.93502L8.76569 5.08676C9.02891 6.14358 9.85408 6.96874 10.9109 7.23196L13.0626 7.7679C13.3053 7.82834 13.3053 8.17323 13.0626 8.23367L10.9109 8.7696C9.85408 9.03282 9.02891 9.85798 8.76569 10.9148L8.22976 13.0665C8.16932 13.3092 7.82443 13.3092 7.76399 13.0665L7.22806 10.9148C6.96483 9.85798 6.13967 9.03282 5.08286 8.7696L2.93111 8.23367C2.68845 8.17323 2.68845 7.82834 2.93111 7.7679L5.08286 7.23196C6.13967 6.96874 6.96483 6.14358 7.22806 5.08676L7.76399 2.93502Z"
          fill="currentColor"
          fillOpacity="0.8"
        />
        <path
          d="M13.0563 1.37536C13.0937 1.22523 13.3071 1.22523 13.3445 1.37536L13.4875 1.94959C13.6544 2.61967 14.1776 3.14287 14.8477 3.30977L15.4219 3.45279C15.572 3.49019 15.572 3.70356 15.4219 3.74096L14.8477 3.88398C14.1776 4.05088 13.6544 4.57408 13.4875 5.24416L13.3445 5.81839C13.3071 5.96852 13.0937 5.96852 13.0563 5.81839L12.9133 5.24416C12.7464 4.57408 12.2232 4.05088 11.5531 3.88398L10.9789 3.74096C10.8287 3.70356 10.8287 3.49019 10.9789 3.45279L11.5531 3.30977C12.2232 3.14287 12.7464 2.61967 12.9133 1.94959L13.0563 1.37536Z"
          fill="currentColor"
          fillOpacity="0.8"
        />
        <path
          d="M2.69689 11.6163C2.7236 11.5091 2.87601 11.5091 2.90272 11.6163L3.05331 12.2209C3.14272 12.5799 3.42301 12.8602 3.78198 12.9496L4.3866 13.1002C4.49384 13.1269 4.49384 13.2793 4.3866 13.306L3.78198 13.4566C3.42301 13.546 3.14272 13.8263 3.05331 14.1853L2.90272 14.7899C2.87601 14.8972 2.7236 14.8972 2.69689 14.7899L2.5463 14.1853C2.45689 13.8263 2.1766 13.546 1.81763 13.4566L1.21301 13.306C1.10577 13.2793 1.10577 13.1269 1.21301 13.1002L1.81763 12.9496C2.1766 12.8602 2.45689 12.5799 2.5463 12.2209L2.69689 11.6163Z"
          fill="currentColor"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_19521_16900">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
